import type {
  ListRootFiCompaniesResponseV4,
  RootfiIntegrationListItem,
} from '@commenda/types';
import { SWRFetcher } from '@commenda/utils';
import { RootfiCompanyUseCase } from '@prisma/client';
import useSWR from 'swr';

import { rootFiConnectionServesUseCase } from '@commenda/utils';
import type { UseRootFiIntegrationsResult } from './types';

/**
 * RootFi integrations for a corporation, scoped by product `useCase`
 * (`GET rootfi/company?corporationId=&useCase=`).
 */
export function useRootFiIntegrations(
  corporationId: number | null | undefined,
  useCase: RootfiCompanyUseCase
): UseRootFiIntegrationsResult {
  const id = corporationId != null && corporationId > 0 ? corporationId : null;

  const { data, error, mutate, isLoading } =
    useSWR<ListRootFiCompaniesResponseV4>(
      id
        ? `rootfi/company?corporationId=${id}&useCase=${encodeURIComponent(
            useCase
          )}&include=scopeData&include=inviteLink`
        : null,
      async (url: string) =>
        SWRFetcher({ method: 'GET' })(
          url
        ) as Promise<ListRootFiCompaniesResponseV4>
    );

  const integrations: RootfiIntegrationListItem[] =
    data?.companies.filter(
      (row) => row.integration != null && rootFiConnectionServesUseCase(row, useCase)
    ) ?? [];

  return {
    data: integrations,
    error,
    mutate,
    isLoading,
  };
}
